import { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from "@mui/material/Box";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormHelperText from '@mui/material/FormHelperText';
import {useOutletContext } from "react-router-dom";

const ClientAccCustomPDTitleChangeDialog = ({ open, setOpen, extraLogicHandlerOnOK, selectedDataObj, tableData, setTableData }) => {

    // console.log("111-dataObj", selectedDataObj)

    useEffect(() => {
        if (!!open) {
            setOpen(true)
        } else {
            setOpen(false)
        }
    }, [open])

    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
    };

    /**
     {
        Id: "1",
        ProgramDescripitorTitle: "abc1",
        ProgramDescripitorFileName: "abc1.txt",
      }
     */

    const schema = yup.object().shape({
        clientAccPDTitle: yup.string().label('This field').required().max(200),
    });

    const rhfFormInstanceForPD = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            Id: "",
            clientAccPDTitle: "",
            ProgramDescripitorFileName: "",
        },
    });

    const { setValue, watch } = rhfFormInstanceForPD

    const inputClientPDTitle = watch("clientAccPDTitle")

    useEffect(() => {
        if (!!selectedDataObj && !!Object.keys(selectedDataObj).length) {
            setValue("Id", selectedDataObj?.Id, { shouldValidate: true });
            setValue("clientAccPDTitle", selectedDataObj?.clientAccPDTitle, { shouldValidate: true });
            setValue("ProgramDescripitorFileName", selectedDataObj?.ProgramDescripitorFileName);
        }
    }, [selectedDataObj])


    const onSubmitForPD = (data, e) => {
        /**send Data to parent component */

        let list = []

        if (!!tableData && !!tableData.length) {
            tableData.forEach((item) => {
                if (item?.Id !== data?.Id) {
                    list.push(item)
                } else {
                    list.push({
                        ...item,
                        clientAccPDTitle: data?.clientAccPDTitle,
                        /**for custom clientAccPDTitle and  ProgramDescripitorTitle have same title*/
                        ProgramDescripitorTitle: data?.clientAccPDTitle
                    })
                }
            })
        }
        setTableData(list)

        handleClose()
    };
    
    const resourcesCMSData = useOutletContext(); //getting data from Super parent

    const fetchClientAccResDtlsLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["ClientAccountResourcesDetails"]) {
        const resourcesCMSDataLabel = resourcesCMSData.pageContent["ClientAccountResourcesDetails"];
        return returnLabel(resourcesCMSDataLabel?.Labels, key)
        }
    }

    const fetchCommonCMSLabel = (key) => {
        if (resourcesCMSData && resourcesCMSData?.pageContent["CommonComponent"]) {
            const commonCMSDataLabel = resourcesCMSData.pageContent["CommonComponent"];
            return returnLabel(commonCMSDataLabel?.Labels, key)
        }
        return '';
    }

    const returnLabel = (labelArray, key) => {
        if (labelArray.length > 0 && key) {
            return labelArray.find((x) => x.Key === key)?.Phrase || '';
        }
        return '';
    }

    /**only custome PD title validation  */
    let arrayOfAllClientPDTitles = []
    !!tableData && tableData.forEach((eachItem) => {
        if (eachItem?.Id !== selectedDataObj?.Id) {
            arrayOfAllClientPDTitles.push(eachItem?.ClientAccountProgramDescripitorTitle)
        }
    })
    const [clientPDTitleFieldErrorMsg, setClientPDTitleFieldErrorMsg] = useState("")
    useEffect(() => {
        if (!!arrayOfAllClientPDTitles.includes(inputClientPDTitle?.trim())) {
            const msg = fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ErrorMsgClientResourceExist') //"This client resource title exists for selected client account."
            setClientPDTitleFieldErrorMsg(msg)
        }
        else {
            setClientPDTitleFieldErrorMsg("")
        }
    }, [arrayOfAllClientPDTitles, inputClientPDTitle])

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(e) => {
                    /**  e.stopPropagation(); required to use form within form seperately to avoid conflicts between nested form submits. */
                    e.stopPropagation();
                    rhfFormInstanceForPD.handleSubmit(onSubmitForPD)(e)
                }}
            >
                <DialogTitle>

                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPD}
                        name={"clientAccPDTitle"}
                        label= {fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ClientResourceTitle')} //{"Client-Resource Title"}
                        fullWidth
                    />
                    {
                        <FormHelperText error={!!clientPDTitleFieldErrorMsg}>
                            {clientPDTitleFieldErrorMsg}
                        </FormHelperText>
                    }

                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPD}
                        name={"clientAccPDTitle"}
                        label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceTitle')} //{"Resource Title"}
                        fullWidth
                        disabled
                    />
                    <MpgInput
                        rhfFormInstance={rhfFormInstanceForPD}
                        name={"ProgramDescripitorFileName"}
                        label={fetchClientAccResDtlsLabel('ClientAccountResourcesDetails.ResourceFileName')} //{"Resource File Name"}
                        fullWidth
                        disabled
                    />
                </DialogTitle>
                <DialogContent>

                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        {fetchCommonCMSLabel('Common.Cancel')} {/* Cancel */}
                    </Button>

                    <Button
                        type="submit"
                        disabled={!!clientPDTitleFieldErrorMsg}
                    >
                        {fetchCommonCMSLabel('Common.OK')} {/*OK*/}
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    )
}
export default ClientAccCustomPDTitleChangeDialog